export class BankAmountType {
    bankId: number;
    amountTypeId: number;
}
